import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Badge } from '@aws-amplify/ui-react';
import {
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead
} from '@aws-amplify/ui-react';
import React, { useEffect, useState } from 'react';
import {Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';



const Account = (props) => {
    
    const [typeOfAccount, settypeOfAccount] = useState("");
    const [statusSubscription, setstatusSubscription] = useState("");

    useEffect(() => {
        const token = props.user.signInUserSession.idToken.jwtToken
        const requestInfo = { headers: { Authorization: token } }
        API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
            .then(response => {
                //localStorage.setItem('user_account_type', response.user_account_type)
                settypeOfAccount(response.user_account_type);
                setstatusSubscription(response.status_subscription)
                console.log(response.user_account_type)
            })

            .then(error => {
                console.log(error)
            })

    }, []);


    return (
        <Container>
            <br />
            <Row>
                <Col className="d-flex justify-content-end" >
                    <Nav.Link as={Link} to={'/subscription'}>
                        <Button variant="primary">Change subscription</Button>
                    </Nav.Link>
                    {/* <Button variant="danger" onClick={() => cancelSubscription()}>Cancel subscription</Button> */}
                    {!statusSubscription && (
                    <Nav.Link as={Link} to={'/cancel'}  disabled={typeOfAccount==='free'}>
                        <Button variant="danger"  disabled={typeOfAccount==='free'}>Cancel subscription</Button>
                    </Nav.Link>
                    )}
                </Col>
            </Row>
            <h1>Account</h1>
            <Row>
                <Table
                    caption=""
                    highlightOnHover={false}>
                    <TableBody>
                        <TableRow>
                            <TableCell>Account Id</TableCell>
                            <TableCell>{props.user.username}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Account Files</TableCell>
                            <TableCell>{localStorage.user_files}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Account Pages</TableCell>
                            <TableCell>{localStorage.user_pages}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Query Searches</TableCell>
                            <TableCell>{localStorage.query_searches}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Keyword Searches</TableCell>
                            <TableCell>{localStorage.keyword_searches}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Entity Searches</TableCell>
                            <TableCell>{localStorage.entity_searches}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Row>
        </Container>
    )
}
export default Account;